import React, { useEffect, useState } from 'react';
import { formatMana, MEDALS } from './format.js';

export default function HallOfFamePage() {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState(new Set());

  useEffect(() => {
    fetch('/api/tournaments/hall-of-fame')
      .then(r => {
        if (!r.ok) throw new Error('Failed to load the hall of fame');
        return r.json();
      })
      .then(setEntries)
      .catch(err => setError(err.message));
  }, []);

  const toggle = (userId) => {
    setExpanded(prev => {
      const next = new Set(prev);
      if (next.has(userId)) next.delete(userId);
      else next.add(userId);
      return next;
    });
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🏛️ Hall of Fame</h1>
        <p className="page-subtitle">
          Every winner across all finished tournaments, ranked by titles
        </p>
      </div>

      {error ? (
        <div className="form-error-message">{error}</div>
      ) : entries === null ? (
        <div className="loading">Loading hall of fame...</div>
      ) : entries.length === 0 ? (
        <div className="card">
          <div className="center-message">
            No champions yet — winners appear here once a tournament finishes.
          </div>
        </div>
      ) : (
        <div className="leaderboard hof-list">
          {entries.map((entry, index) => {
            const isExpanded = expanded.has(entry.userId);
            return (
              <div key={entry.userId}>
                <div
                  className={`leaderboard-row expandable ${isExpanded ? 'expanded' : ''}`}
                  onClick={() => toggle(entry.userId)}
                >
                  <div className="leaderboard-user">
                    <span className={`leaderboard-rank ${index < 3 ? 'top-rank' : ''}`}>
                      #{index + 1}
                    </span>
                    {entry.avatarUrl && <img src={entry.avatarUrl} alt="" className="avatar" />}
                    <a
                      href={`/user.html?u=${encodeURIComponent(entry.username || entry.userId)}`}
                      className="leaderboard-name"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {entry.userName}
                    </a>
                  </div>
                  <div className="leaderboard-right">
                    <span className="hof-stats">
                      <span className="hof-stat" title="Tournament wins">🏆 {entry.wins}</span>
                      <span className="hof-stat" title="Podium finishes">🥉 {entry.podiums}</span>
                      {entry.totalWinnings > 0 && (
                        <span className="hof-stat prize-pool" title="Prize winnings">
                          {formatMana(entry.totalWinnings)}
                        </span>
                      )}
                    </span>
                    <span className={`expand-caret ${isExpanded ? 'open' : ''}`}>▾</span>
                  </div>
                </div>

                {isExpanded && (
                  <div className="leaderboard-breakdown">
                    {entry.tournaments.map(t => (
                      <div key={`${t.id}-${t.rank}`} className="breakdown-row">
                        <span className="breakdown-market">
                          {MEDALS[t.rank] || `#${t.rank}`}{' '}
                          <a href={`/tournament.html?id=${t.id}`} className="host-link">
                            {t.name}
                          </a>
                        </span>
                        {t.prize ? (
                          <span className="breakdown-profit profit-positive">{formatMana(t.prize)}</span>
                        ) : null}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
